import { Media } from "components";

import { DamageImageCellProps } from "../DamagedItemsTable.types";

import styles from "../DamagedItemsTable.module.scss";

const DamageImageCell = ({ mediaFile }: DamageImageCellProps) => {
  return (
    <div className={styles.damagedItemsTable_imageCell_thumb}>
      {mediaFile && (
        <Media
          mediaFile={mediaFile}
          className={styles.damagedItemsTable_imageCell}
        />
      )}
    </div>
  );
};

export default DamageImageCell;
